import React, { FunctionComponent } from "react";
import { Switch, Route, withRouter, RouteComponentProps } from "react-router";
import {Departments} from "./Departments";

const DepartmentManagementRoutes: FunctionComponent<RouteComponentProps> = ({
  match: { url }
}) => (
  <Switch>
    <Route exact path={`${url}/`} render={() => <Departments />} />
    
  </Switch>
);

export const DepartmentManagement = withRouter(DepartmentManagementRoutes);